import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Label, Form } from "reactstrap";
import "../assets/scss/kendo-theme-custom.scss";

import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";
import "react-hammerjs";

import moment from "moment";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";

import { useLocation, useNavigate } from "react-router-dom";
import DataProductTreeSelector from "../components/DataQuality/DataProductTreeSelector";
import FilterSubmit from "../components/DataQuality/FilterSubmit";
import {
  fetchStatusCount,
  setFilterStatusCount,
} from "../store/app/DataRollCall/DataRollCallSlice";
import FilterOverlay from "../components/filterOverlay/FilterOverlay";

const DataRollCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const isSpinnerVisible = useSelector(
    (state) => state.dataRollCallReducer.loading
  );
  const dataCheck = useSelector((state) => state.dataQualityReducer.dataCheck);
  const filterDomains = useSelector(
    (state) => state.dataQualityReducer.filterDomains
  );
  const filterDataProducts = useSelector(
    (state) => state.dataQualityReducer.filterDataProducts
  );

  const statusCount = useSelector(
    (state) => state.dataRollCallReducer.statusCount
  );

  useEffect(() => {
    dispatch(fetchStatusCount(filterDomains, filterDataProducts));
  }, [location.search]);

  const onSeriesClick = (serie) => {
    console.log("serie: ", serie);
    console.log("statusCount", statusCount);
    const data = statusCount.find(
      (item) => item.roll_call_status_name === serie.category
    );
    console.log("data", data);
    dispatch(setFilterStatusCount([data.roll_call_status_id]));
    searchParams.set(
      "rollcallstatus",
      JSON.stringify([data.roll_call_status_id])
    );
    data.roll_call_status_id == 1 || data.roll_call_status_id == 2
      ? navigate(
          "/data-roll-call/detail/product-type-list-roll-call?" + searchParams
        )
      : navigate(
          "/data-roll-call/detail/version-list-roll-call?" + searchParams
        );
  };

  return (
    <>
           <Form>
        <Row className="bg-light-primary px-4 py-2">
          <Col>
            <Row className="align-items-end g-2">
              <Col xs="12" sm="auto" className="flex-grow-1">
                <Label for="categoryName" className="mb-1 small">Data Products</Label>
                <DataProductTreeSelector />
              </Col>
              
              <Col xs="12" sm="auto" className="d-flex align-items-end ms-sm-auto">
                <FilterSubmit color="primary" text="Filter" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Container fluid className="py-2 px-4  position-relative ">
        <Row className="row g-3 mb-3">
          <Col>
            <div className="py-2 px-3">
              <p className="my-2 lh-sm">
                Generated on {moment().format("D/M/Y")} at{" "}
                {moment().format("H:m:s")}. Total Roll-Calls:{" "}
                {statusCount.reduce((acc, item) => acc + item.count, 0)}.
              </p>
              <Chart
                onSeriesClick={onSeriesClick}
                style={{
                  height: 460,
                }}
              >
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    categories={statusCount?.map(
                      (item) => item.roll_call_status_name
                    )}
                  ></ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    style={{ cursor: "pointer" }}
                    type="bar"
                    gap={0.5}
                    spacing={0.25}
                    data={statusCount?.map((item) => item.count)}
                    color={(point) => statusCount[point.index].info.color}
                  />
                </ChartSeries>
                <ChartValueAxis>
                  <ChartValueAxisItem majorUnit={1} />
                </ChartValueAxis>
              </Chart>
            </div>
          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
        <FilterOverlay isVisible={dataCheck} />
      </Container>
    </>
  );
};

export default DataRollCall;
